


export function createPageUrl(pageName: string) {
    return '/' + pageName.replace(/ /g, '-');
}

/** נתיב פנימי בלבד אחרי prefetch (מונע open redirect) */
export function getSafePrefetchReturnPath(raw: string | null | undefined): string | null {
    if (raw == null || typeof raw !== "string") return null;
    const t = raw.trim();
    if (!t.startsWith("/") || t.startsWith("//")) return null;
    if (/^[a-zA-Z][a-zA-Z+\-.]*:/.test(t)) return null;
    return t;
}